import React from 'react'

interface CardProps {
  className?: string
}

export const Card = ({ className, children }: React.PropsWithChildren<CardProps>) => (
  <div className={[`bg-white rounded-lg shadow-md`, className].filter(Boolean).join(' ')}>{children}</div>
)
